import React from "react";
import "./Step2of4Gadget.css";
import { Modal, Button } from 'react-bootstrap';
import { Row, Col } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useState } from "react";
import Navbar from "../../../../Components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {ErrorToast} from "../../../../Components/Navbar/Toast/Toast";
import ColonnaSx from "../../../../Components/Colonne/ColonnaSx";
import BreadcrumbBt from "../../../../Components/Footer/BreadcrumbBt";
import {Helmet} from "react-helmet";
export default function Step2of4Gadget() {
  const navigate = useNavigate();
  const now = 60;

  //variabili da passare tra i vari steps
  const sendoption    = localStorage.getItem("sendoption");

  const step2Quantity = localStorage.getItem("step2Quantity");
  const nazione       = localStorage.getItem("nazione");

  const step4Gadget   = localStorage.getItem("step4Gadget");
  const step4Peso     = localStorage.getItem("step4Peso");
  const step4Misure   = localStorage.getItem("step4Misure");

  const step4Colore     = localStorage.getItem("step4Colore");
  //fine variabili da passare tra i vari steps

  //const [sendItem, setItem] = useState();

  //useEffect(() => {
    //setItem(localStorage.getItem("sendoption"));
  //});
  const [modalShow, setModalShow] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [gadgetweight, setGadgetWeight] = useState(step4Peso ? step4Peso : "");
  const [dropselectedValue, setDropSelectedValue] = useState(step4Gadget ? step4Gadget : "");
  const [measurement, setmeasurementValue] = useState(step4Misure ? step4Misure : "");

  // Aggiungi le funzioni per aprire e chiudere il modale
  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);

  const handleModalSelect = (gadgetName) => {
    setDropSelectedValue(gadgetName);
    handleClose(); // Chiude il modale dopo la selezione
  };

  const [isChecked1, setIsChecked1]   = useState(step4Colore === "Bianco/Nero" );
  const [isChecked2, setIsChecked2]   = useState(step4Colore === "Colore" );

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);
    //console.log("Measurement is", value);
  };


  const handlePersonalizzatoInput = (e) => {
    const value = e.target.value;
    setmeasurementValue(value);
    //console.log("Measurement Value is", value);
  };

  const handleChangeGadget = (e) => {
    const value = e.target.value;
    setGadgetWeight(value);
   // console.log("Gadget Weight is", value);
  };

  const gadgets = [
    { id: 1, name: "Altro" },
    { id: 2, name: "Braccialetti" },
    { id: 3, name: "Cappellini" },
    { id: 4, name: "Calendari" },
    { id: 5, name: "Card / Tessere" },
    { id: 6, name: "Cosmetici" },
    { id: 7, name: "Block notes personalizzati" },
    { id: 8, name: "Magliette" },
    { id: 9, name: "Penne / matite" },
    { id: 10, name: "Porta Badge (ciondolini)" },
    { id: 11, name: "Portachiavi" },
    { id: 12, name: "Pendrive" },
    { id: 13, name: "Segnalibri" }
  ];

  const DropdownhandleChange = (eventKey) => {
    setDropSelectedValue(eventKey);
  };

  const handleRoutes = () => {

    localStorage.setItem("step4Gadget", dropselectedValue);
    localStorage.setItem("step4Peso", gadgetweight);
    localStorage.setItem("step4Misure", measurement);

    if (( dropselectedValue =='Altro' && measurement ) || ( dropselectedValue !== 'Altro' && dropselectedValue != ""  ) && gadgetweight) {
      navigate(`/Lettere/Step-6`);
    }
  };

  const formValidation = () => {
    if (dropselectedValue === "") {
      ErrorToast("Seleziona il tipo di gadget");
      return false;
    }
    if (dropselectedValue === "Altro" && measurement === "") {
      ErrorToast("Inserisci il tipo di gadget");
      return false;
    }
    if (gadgetweight === "") {
      ErrorToast("Inserisci il peso del gadget");
      return false;
    }
    return true;

  }

  async function nextstep() {
    try {

      if (!formValidation()) {
        return;
      }

      handleRoutes();

    } catch (error) {
      console.log(error);
    }
  }

  const breadcrumbArray = [
    { value: sendoption,          url: "/Step-1" },
    { value: step2Quantity,       url: "/Step-2" },
    { value: nazione,             url: "/Step-3" },
    { value: "Dettaglio",         url: "/Cataloghi/Step-4" },
  ];

  const goBack = () => {
    navigate('/Gadget/Step-4');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <ToastContainer />
      <div className="over-flow-setting">
        <Navbar />
        <div>
          <Row className="step1-row">
            <ColonnaSx />
            <Col md={8} className="col-rhs">
              <div className="top-rhs">
                <ProgressBar now={now} />
              </div>

              <div className="col-rhs-inner-custom">
                <div>
                  <p className="step4-txt">
                    Step 4:
                    <span className="step4-txt-sp1"> Dettagli Gadget </span>
                  </p>
                  <p className="rhs-st4-des">
                    Scegli la qualità e il tipo della stampa che preferisci.
                  </p>
                </div>

                <div className="rhs-form-gadget2-body">
                  <div className="size-contain">
                    <form className="form-envelope-main">

                        <div className="form-group cartoline-form-drop-width gadget-drop">
                          {/* Modale per la selezione dei gadget */}
                          <Modal show={modalShow} onHide={handleClose} centered>
                            <Modal.Header closeButton>
                              <Modal.Title>Seleziona un Gadget</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <ul  className="modal-ul">
                                {gadgets.map((gadget) => (
                                    <li key={gadget.id} onClick={() => handleModalSelect(gadget.name)} className="gadget-item">
                                      {gadget.name}
                                    </li>
                                ))}
                              </ul>
                            </Modal.Body>
                            <Modal.Footer className="custom-modal-footer">
                              <Button variant="secondary" onClick={handleClose}>
                                Chiudi
                              </Button>
                            </Modal.Footer>
                          </Modal>

                          {/* Pulsante che apre il modale */}
                          <div className="form-group cartoline-form-drop-width gadget-drop">
                            <label className="envelope-label">Tipologia di gadget</label>
                            <div onClick={handleShow} className="custom-drop custom-drop-border">
                              {dropselectedValue === "" ? "Seleziona" : dropselectedValue}
                            </div>
                          </div>
                        </div>
                        <div className={dropselectedValue === "Altro" ? "form-group pg-quantity-gadget" : "d-none"}>
                          <label className="envelope-label">
                            Specifica Gadget
                          </label>
                          <input
                              type="text"
                              className="form-control personalizzato-form"
                              id="exampleInputQuantity"
                              onChange={handlePersonalizzatoInput}
                              placeholder="es. Calendario"
                              value={measurement}
                          />
                        </div>

                      <div className="form-group pg-quantity-cataloghi">
                        <label className="envelope-label">
                          Peso del gadget
                        </label>
                        <input
                            type="text"
                            className="form-control peso-form"
                            id="exampleInputQuantity"
                            onChange={handleChangeGadget}
                            placeholder="es. 90g"
                            value={gadgetweight}
                        />
                        <div className="border-btm"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="btns-envelope">
                <div className="btn-rhs-row-mb">
                  <div>
                    <button className="btn-r1" onClick={goBack}>Indietro</button>
                  </div>
                  <div className="btn2-div">
                    <button
                      className={
                          (( dropselectedValue =='Altro' && measurement ) || ( dropselectedValue !== 'Altro' && dropselectedValue != ""  ) && gadgetweight)
                          ? "btn-r2-active"
                          : "btn-r2"
                      }
                      onClick={nextstep}
                    >
                      Avanti
                    </button>
                  </div>
                </div>
              </div>

              <div className="btn-rhs-row w-100">
                <div>
                  <button className="btn-r1" onClick={goBack}>Indietro</button>
                </div>
                <div className="btn2-div w-100">
                  <button
                    className={
                      (( dropselectedValue =='Altro' && measurement ) || ( dropselectedValue !== 'Altro' && dropselectedValue != ""  ) && gadgetweight)
                        ? "btn-r2-active"
                        : "btn-r2"
                    }
                    onClick={nextstep}
                  >
                    Avanti
                  </button>
                </div>
              </div>
                <BreadcrumbBt breadcrumbArray={breadcrumbArray}  now={now} />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
